<template>
    <div class="clearfix main_center">

        <div class="right-content">
            <el-form ref="form" :model="form" label-width="150px" class="form viewFormWrapper">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>配置信息</span>
                    </div>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="业务类型：">
                                <span>{{form.busTypeName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="form.busType =='CG'">
                            <el-form-item label="采购方式：">
                                <span>{{form.purchaserModeName || form.purchaserMode}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="分类节点：">
                                <span>{{form.classNode }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="节点编号：">
                                <span>{{form.nodeCode }}</span>
                            </el-form-item>
                        </el-col>
                      <el-col :span="12">
                        <el-form-item label="节点名称：">
                          <span>{{form.nodeName }}</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="数据集编码：">
                          <span>{{form.datasetCode }}</span>
                        </el-form-item>
                      </el-col>
                        <el-col :span="12">
                            <el-form-item label="排序：">
                                <span>{{form.sort }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="分组标签：">
                                <!-- <span>{{form.groupMark == 1?'项目':form.groupMark == 2?'标段':""}}</span> -->
                                
                                <span v-if="form.groupMark == 1">项目</span>
                                <span v-else-if="form.groupMark == 2">标段</span>
                                <span v-else-if="form.groupMark == 9">不关联项目标段</span>
                                <span v-else></span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="标准名称：">
                                <span>{{form.standardName }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="支持自定义表单：">
                                <span>{{form.enableCustom==0?"否":"是" }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="form.enableCustom == 1">
                            <el-form-item label="自定义表单id/名称：">
                                <span>{{form.formName || form.formId}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="支持附件类别约束：">
                                <span>{{form.categoryIsOpen?"是":"否" }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="form.categoryIsOpen">
                            <el-form-item label="附件类别编码：">
                                <span>{{form.categoryCode}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="受理：">
                                <span>{{form.enableHandle==0?"否":"是" }}</span>
                            </el-form-item>
                        </el-col>
                      <el-col :span="12" v-if="form.enableHandle==1">
                        <el-form-item label="受理角色：">
                          <span>{{form.handleRole}}</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="开启预警：">
                                <span>{{form.warnEnable==0?"关闭":"开启"}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="是否是项目监管节点：">
                                <span>{{form.supperVisionFlag==0?"否":"是"}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="关联视角：" style="width:100%;">
                                <el-tag v-for="item in form.linkrolesVos" :key="item.id" class="angle_tag"
                                >{{angleTypeMap[item.angleType]}}
                                </el-tag>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>


                <el-card class="box-card" style="margin-top:10px">
                    <div slot="header" class="clearfix">
                        <span>预警项信息</span>
                    </div>

                    <!--                <div style="position: relative;top:-10px">
                                      <el-button size="small"  icon="el-icon-plus" type="primary" @click="routerAdd">新增</el-button>
                                      <el-button size="small" icon="el-icon-delete" type="primary"
                                                 @click="deleteSelectItem()">删除
                                      </el-button>
                                    </div>-->
                    <el-table :data="tableData" ref="multipleTable" stripe border
                    >
                        <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                                         :show-overflow-tooltip='true'></el-table-column>
                        <el-table-column fixed type="selection" align="center"
                                         :show-overflow-tooltip='true'></el-table-column>
                        <!--                  <el-table-column label="操作" align="center" width="100">
                                            <template slot-scope="scope">
                                                     <el-button type="text" title="查看" @click="router(scope.row)">查看</el-button>
                                                   <el-button type="text" title="删除" @click="deleteById(scope.row)">
                                                        删除
                                                      </el-button>
                                            </template>
                                          </el-table-column>-->


                        <el-table-column label="预警项名称" prop='itemName' header-align="center" align="left"
                                         min-width='100'
                                         :show-overflow-tooltip='true'></el-table-column>
                        <el-table-column label="预警项编号" prop='itemCode' header-align="center" align="left"
                                         min-width='100'
                                         :show-overflow-tooltip='true'></el-table-column>
                        <el-table-column label="通知角色id集合" prop='notifyRole' header-align="center" align="left"
                                         min-width='110'
                                         :show-overflow-tooltip='true'>
                        </el-table-column>
                        <el-table-column label="状态" prop='openEnable' header-align="center" align="center"
                                         min-width='60'
                                         :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                                <el-tag size="small" :hit="false" effect="plain">
                                    {{scope.row.openEnable==0?"关闭":"开启"}}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="预警内容" prop='warnContent' header-align="center" align="center"
                                         min-width='120'
                                         :show-overflow-tooltip='true'>
                        </el-table-column>
                        <el-table-column label="预警类型" prop='warnTypeName' header-align="center" align="center"
                                         min-width='100'
                                         :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                                <el-tag size="small" :hit="false" effect="plain"> {{scope.row.warnTypeName}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="普通预警" header-align="center" align="center" min-width='100'
                                         :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                                <el-tag size="small" :hit="false" effect="plain"> {{scope.row.genComporName}}</el-tag>
                                {{scope.row.genLimit}} {{scope.row.genUnitName}}
                            </template>

                        </el-table-column>
                        <el-table-column label="严重预警" header-align="center" align="center" min-width='100'
                                         :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                                <el-tag size="small" :hit="false" effect="plain"> {{scope.row.seriComporName}}</el-tag>
                                {{scope.row.seriLimit}} {{scope.row.seriUnitName}}
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- <el-pagination background
                                   layout="sizes, prev, pager, next"
                                   :page-sizes="[10, 20, 50, 100]"
                                   :page-size="pageSize"
                                   :total="total"
                                   :current-page="pageIndex"
                                   @size-change="sizeChangeHandle"
                                   @current-change="currentChangeHandle"></el-pagination> -->
                                   <pagination
                                            class="limit"
                                            :page-sizes="[10, 20, 50, 100]"
                                            :total="total"
                                            :page.sync="pageIndex"
                                            :limit.sync="pageSize"
                                            @pagination="paginationChange">
                                    </pagination>  
                </el-card>


            </el-form>
        </div>
        <div class="left-content">
            <div class="left-navbar">
                <el-button type="primary" size="small" plain style="margin-right:10px;"
                           v-if="hasBtnPermission('btn_jz_pm_dgwitness_busflow_configs_add')"
                           @click="routerEdit()">编辑
                </el-button>
                <el-button size="small" @click="backBtn">返回</el-button>
            </div>
        </div>

    </div>
</template>

<script>

    import {mapState} from "vuex";
    import {tabsCloseCurrentHandle} from '@/utils/routeTab';
    import Pagination from '@/components/Pagination.vue';
    export default {
        components: {Pagination},
        data() {
            return {
                tableMaxHeight: document.documentElement.clientHeight - 267,
                cardHight: (document.documentElement.clientHeight - 116) + 'px',
                form: {
                    busType: '',//业务类型
                    busTypeName: '',
                    purchaserMode:"", // 采购方式
                    purchaserModeName:"",
                    nodeName: '',//节点名称
                    nodeCode: '',//节点编号
                    classNode: '',//分类节点
                    warnEnable: '',//开启预警
                    sort: '',//排序
                    datasetCode: '',//数据集编码
                    standardName:'',
                    formId: '',//表单id
                    enableHandle: '',  //是否受理 0否 1是
                    enableCustom: '',//是否支持自定义表单  0否 1是
                    linkrolesVos: [],//关联视角
                    handleRole:[],
                },
                id: '', //点击提交的时候也传id
                tableData: [],
                pageSize: 10,//每页条数
                pageIndex: 1,//当前页
                total: 0,//总条数,
                parterList: [],
            }
        },
        computed: {
            ...mapState({
                stateData: state => state.user
            }),
            angleTypeMap:function () {
                let map=new Map();
               if(this.parterList){
                   this.parterList.map(p=>map[p.value]=p.name);
               }
               return map;
            }
        },
        activated() {

            this.id = this.$route.query.id;
            this.getDataById();
            this.getDataList();
            this.getDic('jz_dgwitness_angle');

        },
        methods: {
            ifmove() {
               let tableMaxHeight = document.documentElement.clientHeight - 267;
                this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
                this.$nextTick(() => {
                    this.tableMaxHeight = tableMaxHeight
                })
               // this.getDataList()
            },
            indexMethod(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },
            backBtn() { //返回
              tabsCloseCurrentHandle();
                this.$router.push({
                    name: 'flownode_config_list'
                })
                this.$refs.form.resetFields();
            },
            routerEdit() {
                tabsCloseCurrentHandle();
                this.$router.push({
                    name: 'flownode_config_detail',
                    query:{
                        id:this.id
                    }
                })
            },
            getDataById() { //详情

                if (this.id != "") {

                    this.$http.get('/configs/sysFlowNodeConfig/get?id=' + this.id).then(res => {
                        if (res.data.code == '1') {
                            this.id = res.data.data.id;
                            const data = res.data.data;
                            this.form = {...data};
                            this.form.linkrolesVos=data.linkrolesVos||[]
                        }
                    })

                }
            },


            getDataList() { // 获取列表数据
                this.$http.post('/warnItem/list', {
                    'page': this.pageIndex,
                    'rows': this.pageSize,
                    //'searchKey': this.form.search,
                    // 'filter': this.form
                    'filter': {
                        flowId: this.id
                    }
                }).then(res => {
                    this.tableData = res.data.rows;
                    this.total = res.data.total;
                    this.$refs.multipleTable.doLayout()
                })
            },


            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1
                this.getDataList()
            },

            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            paginationChange(obj){
                this.pageIndex= obj.page||1
                this.pageSize=obj.limit||10
                this.getDataList();
            },
            getDic(type) { // 获取字典
                this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
                    if (res.data.code === '1') {
                        switch (type) {
                            case 'jz_dgwitness_bustype':
                                this.businessTypeNamelist = res.data.data;
                                break;
                            case 'jz_dgwitness_warn_compor':
                                this.warnComporNamelist = res.data.data;
                                break;

                            case 'jz_dgwitness_angle':
                                this.parterList = res.data.data;
                                break;
                        }
                    }
                })
            },

        }


    }
</script>

<style lang="less" scoped>
    .angle_tag{
        margin-right: 10px !important;
    }
</style>